import { render, staticRenderFns } from "./CredAbility.vue?vue&type=template&id=88e79ab6&scoped=true"
import script from "./CredAbility.vue?vue&type=script&lang=js"
export * from "./CredAbility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e79ab6",
  null
  
)

export default component.exports